import { useEffect, useMemo, useState } from 'react';

const ONE_TRUST_ADS_COOKIE = 'C0004';

export const useShallShowAds = () => {
  const [isAdblockDetected, setIsAdblockDetected] = useState<boolean>(!globalThis.googletag?.apiReady);
  const [isAdsConsentGiven, setIsAdsConsentGiven] = useState<boolean>(false);
  const shallShowAds = useMemo(() => !isAdblockDetected && isAdsConsentGiven, [isAdblockDetected, isAdsConsentGiven]);

  useEffect(() => {
    globalThis.googletag.cmd.push(() => setIsAdblockDetected(false));
  }, []);

  useEffect(() => {
    globalThis.oneTrustCookieQueue = globalThis.oneTrustCookieQueue || [];
    globalThis.oneTrustCookieQueue.push((_rodoAccepted, acceptedCookies) => {
      setIsAdsConsentGiven(acceptedCookies.showAds);

      globalThis.OneTrust?.OnConsentChanged((e) => {
        setIsAdsConsentGiven(e.detail.includes(ONE_TRUST_ADS_COOKIE));
      });
    });
  }, []);

  return {
    isAdblockDetected,
    isAdsConsentGiven,
    shallShowAds,
  };
};
